/**
 * Round a clock time UP to the next 5-minute division, matching Flutter's
 * custom-time picker which snaps `TimeOfDay.now()` to 5-minute steps
 * (`time_date_selection_widget.dart`). Used to seed the appointment
 * custom-time field from *now* (12:18 → 12:20; already-aligned times stay put).
 *
 * Returns hour/minute only — the caller applies them to the picked calendar
 * day. A round-up past :55 rolls the hour forward and wraps 23 → 00
 * (e.g. 23:58 → 00:00); the date component is owned by the caller's
 * `pickerDate`, so this never advances the day itself.
 */
export function roundUpToFiveMinutes(d: Date): { hour: number; minute: number } {
  const hour = d.getHours();
  const rounded = Math.ceil(d.getMinutes() / 5) * 5;
  if (rounded >= 60) {
    return { hour: (hour + 1) % 24, minute: 0 };
  }
  return { hour, minute: rounded };
}
